import * as THREE from 'three';

const pendingReplacements = new WeakMap();

// Image data is asynchronous and can be absent after a failed request. Keep the
// requested URL on the texture so saving does not depend on that data.
export function getTextureSource(texture) {
  return texture?.userData?.sourceURL || texture?.image?.currentSrc || texture?.image?.src;
}

// This Three.js version does not copy texture.userData in Texture.clone().
export function cloneModelTexture(texture) {
  const clone = texture.clone();
  clone.userData = { ...texture.userData, sourceURL: getTextureSource(texture) };
  return clone;
}

export function loadModelTexture(url, onLoad, onError) {
  const texture = new THREE.TextureLoader().load(url, onLoad, undefined, onError);
  texture.userData = { ...texture.userData, sourceURL: url };
  return texture;
}

export function replaceMaterialTexture(material, url, anisotropy, onUpdate, onError) {
  const request = {};
  pendingReplacements.set(material, request);
  const previous = material.map;
  const texture = loadModelTexture(url, loaded => {
    if (pendingReplacements.get(material) !== request) return;
    pendingReplacements.delete(material);
    // Pasting another material while loading also supersedes this replacement.
    if (material.map !== previous && material.map !== texture) return;
    material.map = loaded;
    material.needsUpdate = true;
    onUpdate();
  }, () => {
    if (pendingReplacements.get(material) !== request) return;
    pendingReplacements.delete(material);
    // A first image keeps its URL for retry on reload. A failed replacement
    // leaves the previous texture and saved reference intact.
    onError();
  });
  texture.anisotropy = anisotropy;
  texture.minFilter = THREE.LinearFilter;
  if (!previous) {
    material.map = texture;
    material.needsUpdate = true;
  }
}

export function clearMaterialTexture(material) {
  pendingReplacements.delete(material);
  material.map = null;
  material.needsUpdate = true;
}
